import type { IDocument } from "@bbj-types/document";
import type { ObjectId } from "@bbj-types/utils";
import { TypoTooltip } from "@data-display/wrapper/DetectOverflow";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import { CircularProgress, IconButton, Stack, Tooltip, Typography } from "@mui/material";

export interface IUploadFileFieldDocumentProps {
  document: IDocument & { error?: boolean };
  handleRemove: (documentId: ObjectId) => void;
}

export const UploadFileFieldDocument = ({ document, handleRemove }: IUploadFileFieldDocumentProps) => {
  return (
    <Tooltip
      title="Ce document est en cours d’analyse antivirus. Veuillez patienter une trentaine de secondes avant de pouvoir envoyer ce courrier."
      disableHoverListener={document.uploaded || document.error}
      disableInteractive
      arrow
    >
      <Stack sx={{ maxWidth: "100%", gap: 0.5 }}>
        <Stack
          direction="row"
          {...(!document.uploaded && { color: "gray.dark" })}
          sx={{
            alignItems: "center",
            alignSelf: "flex-start",
            gap: 1,
            maxWidth: "100%",
          }}
        >
          <TypoTooltip variant="caption" color={document.error ? "error" : "inherit"} noWrap>
            {document.name}
          </TypoTooltip>
          <Stack sx={{ alignItems: "center", flexShrink: 0, width: 32 }}>
            {!document.uploaded && !document.error ? (
              <CircularProgress color="inherit" size="16px" />
            ) : (
              <IconButton color="primary" onClick={() => handleRemove(document._id)} sx={{ p: 0.5 }}>
                <DeleteIcon />
              </IconButton>
            )}
          </Stack>
        </Stack>
        {document.error && (
          <Typography variant="caption" color="error">
            Le document n&apos;a pas pu être importé, vous pouvez le supprimer.
          </Typography>
        )}
      </Stack>
    </Tooltip>
  );
};
